export const ImageTypes = Object.freeze({
    JPG: 'image/jpg',
    JPEG: 'image/jpeg',
    PNG: 'image/png',
});
